import React from 'react';

import { SVGComponentProps } from './svg.types';

const CursorSVG = ({
  fill = 'currentColor',
  size = '32',
  wrapperClass,
  ...otherSvgProps
}: SVGComponentProps) => {
  return (
    <span className={`${wrapperClass || ''}`}>
      <svg
        width={10}
        height={12}
        viewBox="0 0 10 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.1478 7.85999L1.39786 0.109955C1.32727 0.0390014 1.23279 0 1.13281 0C0.925812 0 0.757812 0.167999 0.757812 0.375V11.625C0.757812 11.832 0.925812 12 1.13281 12C1.23434 12 1.33286 11.958 1.4028 11.8855L4.6673 8.50003H8.88284C9.08984 8.50003 9.25784 8.33203 9.25784 8.12503C9.25784 8.02496 9.21884 7.93048 9.1478 7.85999Z"
          fill={fill}
        />
      </svg>
    </span>
  );
};

export default CursorSVG;
